export default __webpack_public_path__ + "static/media/birthday.b59db1ee.webp";